import { render, staticRenderFns } from "./QuoteTemplateLabourView.vue?vue&type=template&id=a7e02192"
import script from "./QuoteTemplateLabourView.vue?vue&type=script&lang=js"
export * from "./QuoteTemplateLabourView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a7e02192')) {
      api.createRecord('a7e02192', component.options)
    } else {
      api.reload('a7e02192', component.options)
    }
    module.hot.accept("./QuoteTemplateLabourView.vue?vue&type=template&id=a7e02192", function () {
      api.rerender('a7e02192', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/quotetemplate/QuoteTemplateLabourView.vue"
export default component.exports